import React, {FC, useEffect, useState} from 'react'
import {Button, Card, Spinner} from 'react-bootstrap'
import {useParams} from 'react-router-dom'
import {
  getPlatformProductAdjustmentAsync,
  getPlatformProductAdjustmentSecondaryAsync,
  getPlatformProductDetailAsync,
  getPlatformProductVarientDetailAsync,
} from 'src/redux/actions/productActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import Loader from 'src/utils/Loader'
import TableLoadingShell from 'src/utils/TableLoadingShell'
import clsx from 'clsx'
import DataTable from 'react-data-table-component'
import moment from 'moment'

import {PageLink, PageTitle} from 'src/marketConnect/layout/core'
import {Link} from 'react-router-dom'
import PremiumBreadcrumb from 'src/app/components/navigation/PremiumBreadcrumb'
import {Varient_Data} from 'src/interfaces/productVariantInterface'
import {VARIANT_DATA} from 'src/interfaces/Platform.interface'
const CommonColumn: FC<{rowData: string}> = ({rowData}) => {
  return (
    <>
      <p>{rowData}</p>
    </>
  )
}

const ProductVariantDetail: FC = () => {
  const params = useParams()

  const [paginationData, setPaginationData] = useState({
    page: 1,
    limit: 10,
  })

  const {
    platformProductVariantDetailLoader,
    platformProductVariantDetail,
    platformAdjustmentCount,
    platformAdjustments,
    platformAdjustmentLoader,
  } = useAppSelector((state) => state.productsOfSingleChannel)

  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (params?.productVariantId) {
      dispatch(getPlatformProductVarientDetailAsync({productVarientId: params?.productVariantId}))
      // .then((response)=>{
      //     console.log('response varient data', response?.payload?.varients_data)
      //     console.log('response varient data2', platformProductVariantDetail?.varients_data)
      // })
    }
  }, [mainStoreData])

  useEffect(() => {
    if (params?.platformId && params?.variantId && params?.productId) {
      dispatch(
        getPlatformProductAdjustmentSecondaryAsync({
          platformId: params?.platformId,
          otherParams: {
            ...paginationData,
            variant_id: params?.variantId,
            product_id: params?.productId,
          },
        })
      )
    }
  }, [paginationData])

  if (platformProductVariantDetailLoader || platformAdjustmentLoader) return <Loader />

  const variants_table_header_column = [
    {
      name: 'Variant Name',
      cell: (row) => (
        <CommonColumn
          rowData={
            row?.platforminventoryadjustmentsyncdata_set[0]?.updated_product_variant?.name ==
            'Default Title'
              ? row?.platforminventoryadjustmentsyncdata_set[0]?.updated_product_variant
                  ?.platform_product?.name
              : row?.platforminventoryadjustmentsyncdata_set[0]?.updated_product_variant
                  ?.platform_product?.name
          }
        />
      ),
      sortable: false,
      grow: 2,
    },
    {
      name: 'Available Quantity',
      cell: (row) => (
        <p className='mb-0'>{row?.platforminventoryadjustmentsyncdata_set[0]?.updated_quantity}</p>
      ),

      sortable: false,
      right: true,
      center: true,
    },

    // {
    //   name: 'Price',
    //   cell: (row) => <CommonColumn rowData={row?.product_variant?.price?.value} />,
    //   sortable: true,
    //   right: true,
    //   center: true,
    // },

    {
      name: 'Created At',
      cell: (row) =>
        row ? (
          <CommonColumn
            rowData={moment
              .utc(new Date(row?.platforminventoryadjustmentsyncdata_set[0]?.created_at))
              .format('hh:mm A,  DD MMM YY')}
          />
        ) : null,
      sortable: true,
      sortField: 'api_created_at',
    },
    {
      name: 'Status',
      cell: (row) => (
        <p className='mb-0'>
          {row?.platforminventoryadjustmentsyncdata_set[0]?.destination_sync_status}
        </p>
      ),
      sortable: true,
      sortField: 'Status',
    },
  ]

  const handleSort = (ev, sortDirection) => {
    setPaginationData((pre) => {
      return {...pre, sort_by: ev.sortField, sort_order: (sortDirection + '').toUpperCase()}
    })
  }

  const product_variant_detail = platformProductVariantDetail?.varients_data.length && 
    platformProductVariantDetail?.varients_data.find(
      (item: VARIANT_DATA) => item?.id === Number(params?.productVariantId)
    )
  
  return (
    <>
      {/* <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6'>
        <li className='nav-item'>
          <a className='nav-link fs-5 fw-bold active text-grey-900' data-bs-toggle='tab' href='#kt_tab_pane_4'>
            General Info
          </a> */}
      {/* <Breadcrum /> */}
      {/* <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3 '>
              <Link to='/listing-product-table/37' className='pe-3 text-muted'>
                Product Tabel
              </Link>
            </li>
            <li className='breadcrumb-item px-3 text-muted'>Product Detail</li>
          </ol>
        </li>
      </ul> */}
      <div
        id='kt_page_title'
        data-kt-swapper='true'
        data-kt-swapper-mode='prepend'
        data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
        className='page-title d-flex flex-wrap me-3 flex-column justify-content-center mb-4'
      >
        <div className='d-flex flex-column'>
          <PremiumBreadcrumb
            items={[
              {
                label: 'Product Table',
                to: `/listing-product-table/${params?.platformId}`,
              },
              { label: 'Linked Product Detail' },
            ]}
          />
          <h1 className='page-heading d-flex text-gray-900 fw-bold fs-3 my-0 flex-column justify-content-center'>
            General Info
          </h1>
        </div>
      </div>

      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade show active' id='kt_tab_pane_4' role='tabpanel'>
          <div className='card'>
            <div className='p-4'>
              <div className='border border-bottom border-top-0 border-start-0 border-end-0 py-2'>
                <label htmlFor='' className='fs-5 text-secondary fw-bold'>
                  Product Details
                </label>
              </div>
              <div className='py-4'>
                {/* <div className='card'>
                  <div className='border border-bottom p-2'>
                    <p className='h5 fw-bold'>Product Name</p>
                  </div>
                </div> */}
              <div className="mt-2 p-4">
  <div className="h4 mb-0 text-info">
    {platformProductVariantDetail?.name}
  </div>

  <div className="row mt-3">
    {product_variant_detail ? (
      product_variant_detail.parent_details.map((item: any, index: number) => (
        <div className="col-md-4 mb-4" key={index}>
          <div className="position-relative mt-4">
            {/* Floating Label */}
            <div
              className="position-absolute top-0 start-50 translate-middle bg-white px-3 text-secondary fw-bold"
              style={{
                transform: 'translate(-50%, -50%)',
                zIndex: 1,
                whiteSpace: 'nowrap',
              }}
            >
              Linked to {item.type}
            </div>

            {/* Card */}
            <div className="card shadow-sm border-secondary pt-3">
              <div className="card-body ps-3 py-2 fs-5 fw-medium" style={{color: 'dimgray'}}  >
                <div className="mb-2">
                  <span>Name :</span> <span className='' style={{color: 'gray'}}>{item.name || 'N/A'}</span>
                </div>
                <div className="mb-2">
                  <span>SKU &nbsp;&nbsp; :</span> <span className='' style={{color: 'gray'}}>{item.sku || 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p>Variant not found</p>
    )}
  </div>
</div>




                {/* <div className='card mt-4'>
                  <div className='border border-bottom p-2'>
                    <p className='h5 fw-bold'>Product Type</p>
                  </div>
                  <div className='d-flex align-items-center mt-2 p-4'>
                    <p className='h4 mb-0 text-info'>{platformProductVariantDetail?.product_type}</p>
                  </div>
                </div> */}

                {/* <div className='card mt-4'>
                  <div className='border border-bottom p-2'>
                    <p className='h5 fw-bold'>Images</p>
                  </div>
                </div> */}
                <div className='d-flex align-items-center mt-2 p-4  justify-content-around flex-wrap'>
                  {platformProductVariantDetail?.image_set.length
                    ? platformProductVariantDetail?.image_set.map((item, index) => {
                        return (
                          <div className='shadow p-2 rounded'>
                            <img
                              src={item?.image_url}
                              alt={item.image_position}
                              className='w-140px h-80px'
                            />
                          </div>
                        )
                      })
                    : null}
                </div>

                {/* <div className='card mt-4'>
                  <div className='border border-bottom p-2'>
                    <p className='h5 fw-bold'>Tags</p>
                  </div>
                  <div className='d-flex align-items-center mt-2 p-4'>
                    <p className='h5 mb-0 text-secondary'>{platformProductVariantDetail?.tags}</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className='p-4'>
            <div className='pt-4'>
              {params?.platformId !== mainStoreData?.id!.toString() ? (
                <div className='card mt-4'>
                  <div>
                    <label htmlFor='' className='fs-5 text-secondary fw-bold p-2'>
                      Inventory Logs
                    </label>
                    <TableLoadingShell loading={platformAdjustmentLoader} minHeight="60vh">
                    <DataTable
                      title={'Adjustment of ' + platformProductVariantDetail?.name}
                      fixedHeader={true}
                      onSort={handleSort}
                      columns={variants_table_header_column}
                      progressPending={false}
                      pagination
                      paginationServer
                      paginationTotalRows={platformAdjustmentCount}
                      data={platformAdjustments}
                      // selectableRows
                      onChangePage={(pageNumber, totalRows) => {
                        setPaginationData((pre) => {
                          return {...pre, page: pageNumber}
                        })
                      }}
                      onChangeRowsPerPage={(currentPage) => {
                        setPaginationData((pre) => {
                          return {...pre, limit: currentPage}
                        })
                      }}
                      // onChangePage={(pageNumber, totalRows) => {
                      //   dispatch(getProductsListAsync({id: pageNumber.toString(), subparams:{page:pageNumber} }))
                      // }}

                      // subHeader
                      // subHeaderComponent={subHeaderComponentMemo}
                      customStyles={{
                        table: {
                          style: {
                            height: '60vh',
                          },
                        },
                        headCells: {
                          style: {fontWeight: 'bold', fontSize: '14px'},
                        },
                        cells: {
                          style: {
                            padding: '10px',
                            borderBottom: '1px solid gainsboro',
                          },
                        },
                      }}
                    />
                    </TableLoadingShell>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {/* <div className='tab-pane fade' id='kt_tab_pane_5' role='tabpanel'>
        </div>
        <div className='tab-pane fade' id='kt_tab_pane_6' role='tabpanel'>
          <div style={{height: '100vh'}} className='overflow-scroll'>
            <div dangerouslySetInnerHTML={{__html: platformProductVariantDetail?.description ?? ''}}></div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default ProductVariantDetail
